import React from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import Switch from 'react-switch';

//image
import leftArrow from '/public/Icons/switchLeftArrow.svg';
import rightArrow from '/public/Icons/switchRightArrow.svg';

export const uncheckedIcon = (
    <img src={leftArrow} className='toggleRightArrow' />
);

export const checkedIcon = (
    <img src={rightArrow} className='toggleLeftArrow' />
);

class SwitchButton extends React.Component {

    static defaultProps = {
        checked: false,
        checkedValue: true,
        unCheckedValue: false,
        offColor: '#E4E4E4',
        onColor: '#E4E4E4',
        offHandleColor: '#0D0D0D',
        onHandleColor: '#0D0D0D',
        checkedIcon: checkedIcon,
        uncheckedIcon: uncheckedIcon,
        height: 32,
        width: 47,
        boxShadow: 'none',
        activeBoxShadow: 'none',
        isPersonalize: false
    };

    render() {
        const { switchOnLabel, switchOffLabel, checked, onChange, disabled } = this.props;
        const { offColor, onColor, checkedIcon, uncheckedIcon, height, width, boxShadow, handleDiameter, offHandleColor, onHandleColor } = this.props;

        return (
            <div>
                {
                    String(checked) && (
                        <div>
                            {
                                switchOnLabel && switchOffLabel && (
                                    <label>
                                        {checked ? switchOnLabel : switchOffLabel}
                                    </label>
                                )
                            }
                            <Switch
                                id="open-type"
                                checked={checked}
                                onChange={onChange}
                                offColor={offColor}
                                onColor={onColor}
                                onHandleColor={onHandleColor}
                                offHandleColor={offHandleColor}
                                handleDiameter={handleDiameter ? handleDiameter : 30}
                                checkedIcon={checkedIcon}
                                uncheckedIcon={uncheckedIcon}
                                height={height}
                                width={width}
                                boxShadow={boxShadow}
                                disabled={disabled}
                            />
                        </div>
                    )
                }
            </div>
        );
    }
}

const mapState = (state) => ({});

const mapDispatch = {
    change
};

export default connect(mapState, mapDispatch)(SwitchButton);